// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h4[data-v-c6070ba0] {\n  font-size: 13px;\n  font-weight: bold;\n}\n.error-msg-block[data-v-c6070ba0] {\n  font-size: 12px;\n  line-height: 15px;\n  color: #000;\n}\n", ""]);
// Exports
module.exports = exports;
